// extracted by mini-css-extract-plugin
export default {"seriesInfiniteCalendarPane":"PageTemplate-common-module__seriesInfiniteCalendarPane___1X1HC"};